import Image from 'next/legacy/image';
import { FC } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { carmaGenericImageLoader } from 'src/general/helpers/carmaGenericImageLoader';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './ResultCard.module.scss';

type ResultCardProps = {
  carsFound: string;
};

const block1: string[] = ['hatch', 'suv', 'van', 'ute'];
const block2: string[] = ['van', 'ute', 'hatch', 'suv'];
const block3: string[] = ['ute', 'hatch', 'suv', 'van'];

const ImagesTrack: FC<{ images: string[] }> = ({ images }) => (
  <div className={styles.track}>
    {images.map((image) => (
      <div className={styles.trackImage} key={image}>
        <Image
          src={`/images/components/PersonalizedQuote/${image}.svg`}
          layout="fill"
          objectFit="cover"
          alt=""
          loader={carmaGenericImageLoader}
        />
      </div>
    ))}
    {images.map((image) => (
      <div className={styles.trackImage} key={image}>
        <Image
          src={`/images/components/PersonalizedQuote/${image}.svg`}
          layout="fill"
          objectFit="cover"
          alt=""
          loader={carmaGenericImageLoader}
        />
      </div>
    ))}
  </div>
);

export const ResultCard: FC<ResultCardProps> = ({ carsFound }) => (
  <div className={styles.root} data-testid="ResultCard">
    <div className={styles.imagesContainer}>
      <div className={styles.tracksWrapper}>
        <ImagesTrack images={block1} />
        <ImagesTrack images={block2} />
        <ImagesTrack images={block3} />
      </div>
    </div>
    <div className={styles.content}>
      <div className={styles.title} data-testid="result-car-title">
        {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_RESULT_CARD_TITLE, true, { carsFound })}
      </div>
      <div className={styles.description}>{getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_RESULT_CARD_DESCRIPTION)}</div>
    </div>
  </div>
);
